<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :is-valid="isFilterBuilderValid && isFormValid"
    :title="title"
    min-body-height="55vh"
    dialog-width="60%"
    header-shadow
    :agree-text="agreeText"
    @agree="agree"
    no-paddings-x
  >
    <template #body>
      <v-col cols="12">
        <v-form ref="graphForm" v-model="isFormValid">
          <template v-if="isLoaded">
            <v-row no-gutters class="border-bottom pb-4" align="center">
              <v-col cols="3" class="text-left pb-5 pl-7">
                <span> {{ $i18n.t('sidebar.graphGenerationParameters.parameterName') }}: </span>
              </v-col>
              <v-col style="max-width: 275px !important; margin-left: 50px">
                <data-input
                  v-model="computedParameter.name"
                  :data-type="{ name: 'text', max_length: 35 }"
                  :rules="[v => !!v || $i18n.t('rules.required'), v => v.length <= 35 || 'rules.maxLengthExceeded']"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="border-bottom pb-4" align="center">
              <v-col cols="3" class="text-left pb-5 pl-7">
                <span> {{ $i18n.t('sidebar.graphGenerationParameters.parameterDataSource') }}: </span>
              </v-col>
              <v-col style="max-width: 275px !important; margin-left: 50px">
                <data-input
                  v-model="computedParameter.datasource"
                  :items="dataSourcesList"
                  item-text="verbose_name"
                  @change="datasourceChangeHandler"
                  item-value="name"
                  :data-type="{ name: 'select' }"
                  :rules="[v => !!v || $i18n.t('rules.required')]"
                />
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </template>
          <v-col cols="12">
            <expression-builder
              class="expressions"
              ref="builderFilter"
              @update:isValid="isFilterBuilderValid = $event"
              @builderLoaded="onLoaded"
              v-model="computedParameter.filter"
              :is-data-source-selectable="false"
              :main-data-source="computedParameter.datasource"
            />
          </v-col>
        </v-form>
      </v-col>
    </template>
  </main-large-dialog>
</template>

<script>
import DataInput from '@/components/DataInput';
import filters from '@/mixins/filters';
import ExpressionBuilder from '@/components/ExpressionBuilder';
import MainLargeDialog from '@/components/MainLargeDialog';

import { get } from 'vuex-pathify';

export default {
  name: 'GraphGenerationParamsDialog',
  mixins: [filters],
  components: {
    MainLargeDialog,
    DataInput,
    ExpressionBuilder,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    parameterData: {
      type: Object,
    },
    parameters: {
      type: Array,
    },
    parameterIndex: {
      type: Number,
    },
  },
  data: () => ({
    isFormValid: false,
    isLoaded: false,
    payload: {
      name: '',
      datasource: undefined,
      filter: null,
      checked: true,
    },
  }),
  computed: {
    dataSourcesMetadata: get('layers/metadata'),
    epanetDataSources: get('admin/modulesMapping@epanet.datasources'),
    dataSourcesList() {
      return this.$_objectToArray(this.dataSourcesMetadata).filter(datasource =>
        this.epanetDataSources.includes(datasource.name)
      );
    },
    new() {
      return this.parameterData ? false : true;
    },
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    computedParameters: {
      get() {
        return this.parameters;
      },
      set(nV) {
        this.$emit('update:parameters', nV);
      },
    },
    computedParameter: {
      get() {
        return this.new ? this.payload : this.parameterData;
      },
      set(nV) {
        this.$emit('update:parameterData', nV);
      },
    },
    agreeText() {
      return this.new ? 'dialog.agreeAdd' : 'dialog.agreeSave';
    },
    title() {
      return this.new
        ? this.$i18n.t('sidebar.graphGenerationParameters.addExportParameter')
        : this.$i18n.t('sidebar.graphGenerationParameters.editExportParameter');
    },
  },
  methods: {
    agree() {
      let paramsList = [...this.computedParameters];
      if (this.new) {
        paramsList.push(this.payload);
      } else {
        paramsList[this.parameterIndex] = {
          name: this.computedParameter.name,
          datasource: this.computedParameter.datasource,
          filter: this.computedParameter.filter,
          checked: this.computedParameter.checked,
        };
      }
      this.computedParameters = paramsList;
      this.computedIsVisible = false;
    },
    onLoaded() {
      this.isLoaded = true;
    },
    datasourceChangeHandler() {
      this.$refs.builderFilter.clearAllFilteres();
    },
  },
  watch: {
    dataSourcesList: {
      deep: true,
      immediate: true,
      handler(nV) {
        if (nV && !this.payload.datasource) {
          this.payload.datasource = nV[0].name;
        }
      },
    },
    dataSourcesMetadata: {
      deep: true,
      handler(nV) {
        if (!nV[this.computedParameter.datasource]) {
          this.computedParameter.filter = null;
        }
      },
    },
    'computedParameter.datasource'(nV) {
      if (!nV) {
        this.newByIdsFeature.id = null;
      }
    },
    computedIsVisible(nV) {
      if (!nV) {
        this.payload = {
          name: '',
          datasource: this.dataSourcesList[0].name,
          filter: null,
          checked: true,
        };
        this.$refs.builderFilter.clearAllFilteres();
      }
    },
    computedParameter() {
      if (this.new) {
        this.$refs?.graphForm?.resetValidation();
      }
    },
  },
};
</script>
